import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 46 47"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-dasharray": "4 4",
      "stroke-width": "1.5",
      d: "M15.95 36.483H3.586a2 2 0 0 1-2-2V2.793a2 2 0 0 1 2-2h23.759a2 2 0 0 1 2 2v7.517"
    }, null, -1),
    _createElementVNode("path", { d: "m34.103 10.31.53-.53-.219-.22h-.31zm10.31 10.31h.75a.75.75 0 0 0-.219-.53l-.53.53Zm-2 24.63H18.656v1.5h23.759v-1.5ZM17.406 44V12.31h-1.5V44zm1.25-32.94h15.448v-1.5H18.655zm14.698-.75v8.31h1.5v-8.31zm10.31 10.31V44h1.5V20.62zm-7.56.75h8.31v-1.5h-8.31zm-2.53-10.53 10.31 10.31 1.061-1.06-10.31-10.31zm-12.16 25.6h11.104v-1.5H21.414zm0-6.345h18.242v-1.5H21.414zm0-6.345h4.76v-1.5h-4.76zm11.94-5.13a2.75 2.75 0 0 0 2.75 2.75v-1.5c-.69 0-1.25-.56-1.25-1.25zM18.655 45.25c-.69 0-1.25-.56-1.25-1.25h-1.5a2.75 2.75 0 0 0 2.75 2.75zm23.759 1.5a2.75 2.75 0 0 0 2.75-2.75h-1.5c0 .69-.56 1.25-1.25 1.25zM17.405 12.31c0-.69.56-1.25 1.25-1.25v-1.5a2.75 2.75 0 0 0-2.75 2.75z" }, null, -1)
  ]))]))
}
export default { render: render }